import React from "react";
import {
  Box,
  Typography,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TableContainer,
  Paper,
  IconButton,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import ReceiptIcon from "@mui/icons-material/Receipt";

import { Doughnut } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";

ChartJS.register(ArcElement, Tooltip, Legend);

// Dummy Expense Data
const expenseData = [
  {
    id: 1,
    title: "Coffee at Starbucks",
    category: "Food",
    date: "10 July 2025",
    amount: 20,
  },
  {
    id: 2,
    title: "Tricity Bus Pass Payment",
    category: "Travelling",
    date: "12 July 2025",
    amount: 50,
  },
  {
    id: 3,
    title: "Vegetable Purchase",
    category: "Vegetables",
    date: "12 July 2025",
    amount: 20,
  },
  {
    id: 4,
    title: "Tricity Bus Pass Payment",
    category: "Travelling",
    date: "12 July 2025",
    amount: 50,
  },
  {
    id: 5,
    title: "Vegetable Purchase",
    category: "Vegetables",
    date: "12 July 2025",
    amount: 20,
  },
  {
    id: 6,
    title: "Tricity Bus Pass Payment",
    category: "Travelling",
    date: "12 July 2025",
    amount: 50,
  },
  {
    id: 7,
    title: "Vegetable Purchase",
    category: "Vegetables",
    date: "12 July 2025",
    amount: 20,
  },
];

// Breakdown Totals by Category

const BudgetStatsView = ({ expenseData }: { expenseData?: any }) => {
  const chartData = {
    labels: expenseData?.category_wise_sum?.map(
      (cat: any) => cat.category__category_name
    ),
    datasets: [
      {
        data: expenseData?.category_wise_sum?.map((cat: any) => cat.total),
        backgroundColor: [
          "#B69DF8",
          "#B7E5F8",
          "#FAE3AD",
          "#97ffa0ff",
          "#63ceffff",
        ],
        borderWidth: 1,
      },
    ],
  };

  const chartOptions = {
    cutout: "70%",
    plugins: {
      legend: {
        position: "bottom" as const,
      },
    },
  };

  return (
    <>
      <div className="gap_m">
        <div className="w_66">
          <div className="cards view_page mt_20">
            <div className="section_title">
              <h2>Budget Stats</h2>
            </div>
            <TableContainer className="table_container">
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell>Title</TableCell>
                    <TableCell>Category</TableCell>
                    <TableCell>Date</TableCell>
                    <TableCell>Amount</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {expenseData &&
                    expenseData?.expenses?.response_object?.map((row: any) => (
                      <TableRow key={row.id}>
                        <TableCell>{row.title}</TableCell>
                        <TableCell>{row.category}</TableCell>
                        <TableCell>{row.date}</TableCell>
                        <TableCell>AED {row.amount}</TableCell>
                      </TableRow>
                    ))}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        </div>
        <div className="w_33">
          <div className="cards view_page mt_20">
            <div className="section_title">
              <h2>Category Breakdown</h2>
            </div>
            <Box maxWidth={400} mx="auto">
              <Doughnut data={chartData} options={chartOptions} />
            </Box>
          </div>
        </div>
      </div>
    </>
  );
};

export default BudgetStatsView;
